import { render, staticRenderFns } from "./NxSigningModalField.vue?vue&type=template&id=36b14590&scoped=true&"
import script from "./NxSigningModalField.vue?vue&type=script&lang=js&"
export * from "./NxSigningModalField.vue?vue&type=script&lang=js&"
import style0 from "./NxSigningModalField.vue?vue&type=style&index=0&id=36b14590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b14590",
  null
  
)

export default component.exports